import { UISearchResults } from "@flights/types";
import { flightsSessionStore } from "@flights/web-api-utils-universal";
import { trackWithDefaultStage } from "@flights/et-universal";
import {
  isOfMetaOrigin,
  isOfGoogleFlightsOrigin,
  isOfKayakOrigin,
  isOfSkyScannerOrigin,
  isOfWegoOrigin,
  isOfFlygresorOrigin,
  isOfGoogleSearchWidgetOrigin
} from "../utils/marketing-url-params";
import useEvents from "./useEvents";
import useUserAgent from "./useUserAgent";
import useFormatPrice from "./useFormatPrice";
import { useSelector } from "react-redux";
import { getMetaFlight } from "../store/metaFlightDetails/selectors";

const getMetaSource = () => {
  if (isOfGoogleFlightsOrigin()) return "google_flights";
  if (isOfKayakOrigin()) return "kayak";
  if (isOfSkyScannerOrigin()) return "skyscanner";
  if (isOfWegoOrigin()) return "wego";
  if (isOfFlygresorOrigin()) return "flygresor";
  if (isOfGoogleSearchWidgetOrigin()) return "google_search_widget";
  return "unknown_meta";
};

export const useMetaOfferPriceComparison = () => {
  const { grumble } = useEvents();
  const { isMobile } = useUserAgent();
  const { priceToValue } = useFormatPrice();
  const metaFlight = useSelector(getMetaFlight);

  const experimentName = isMobile
    ? "flights_web_cat_pinning_meta_offer_on_sr_mdot"
    : "flights_web_cat_pinning_meta_offer_on_sr_www";

  const metaSource = getMetaSource();

  const compareAndLogPrices = (searchResults: UISearchResults) => {
    const isPinningMetaOfferEnabled = !!trackWithDefaultStage(experimentName, 1);

    if (!isPinningMetaOfferEnabled || !isOfMetaOrigin()) {
      return;
    }

    const landingOfferKey = flightsSessionStore.get("landingOfferKey");

    if (!landingOfferKey || !metaFlight || searchResults.flightOffers.length === 0) return;

    const searchResultOffer = searchResults.flightOffers.find((offer) => offer.offerKeyToHighlight === landingOfferKey);

    if (searchResultOffer) {
      const originalTotal = metaFlight.priceBreakdown?.total;
      const newTotal = searchResultOffer.priceBreakdown?.total;
      const originalPrice = originalTotal ? priceToValue(originalTotal) : null;
      const newPrice = newTotal ? priceToValue(newTotal) : null;
      const originalCurrency = originalTotal?.currencyCode;
      const newCurrency = newTotal?.currencyCode;
      const priceMatch = originalPrice === newPrice && originalCurrency === newCurrency;

      grumble(`Meta offer pinning price comparison (${isMobile ? "mdot" : "www"})`, {
        landingOfferKey,
        metaSource,
        originalPrice,
        originalCurrency,
        newPrice,
        newCurrency,
        priceMatch,
        priceDifference: originalPrice !== null && newPrice !== null ? newPrice - originalPrice : null
      });
    } else {
      grumble(`Meta offer pinning - offer not found in search results (${isMobile ? "mdot" : "www"})`, {
        landingOfferKey,
        metaSource,
        searchResultsCount: searchResults.flightOffers.length
      });
    }
  };

  return { compareAndLogPrices };
};
